
import { defineComponent } from "vue";
import Video from "@/entities/video";
import { videoService } from "@/services";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiArrowLeft } from "@mdi/js";
import VueIFrame from "@/components/IFrame.vue";

export default defineComponent({
  props: {
    videoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      video: null as null | Video,
      mdiArrowLeft,
      fullLoaded: false,
    };
  },
  methods: {
    async getVideo() {
      try {
        this.video = await videoService.getVideo(this.videoId);
        this.fullLoaded = true;
      } catch (error) {
        console.log(`Error \n ${error}`);
      }
    },
  },

  components: {
    SvgIcon,
    VueIFrame,
  },
  async mounted() {
    await this.getVideo();
  },
});
